export default __webpack_public_path__ + "static/FReg-4x3-S_SomethingElse-f6957218d7881d0902a31effc8691635.jpg";